import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../components/layout/Layout';
import { useEmpresa } from '../../../contexts/EmpresaContext';

export default function CampanhasPage() {
  const { empresaSelecionada } = useEmpresa();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('ativas');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showFlowchart, setShowFlowchart] = useState(true);
  const [selectedCampanha, setSelectedCampanha] = useState<any>(null);
  const [showDropdown, setShowDropdown] = useState<number | null>(null);

  // Recarregar dados quando a empresa mudar
  useEffect(() => {
    carregarDadosEmpresa();
  }, [empresaSelecionada.id]);

  const carregarDadosEmpresa = () => {
    // Aqui você carregaria os dados reais da empresa selecionada
    console.log('Carregando campanhas da empresa:', empresaSelecionada.id, empresaSelecionada.nome);
    // Exemplo: buscar campanhas da API baseado no empresaSelecionada.id
  };

  const campanhasAtivas = [
    {
      id: 1,
      nome: 'Vendas Q4 2024',
      tipo: 'Vendas',
      participantes: 45,
      pontos: 1500,
      pontosAdquiridos: 12500,
      pontosDistribuidos: 8750,
      pontosDisponiveis: 3750,
      inicio: '01/10/2024',
      fim: '31/12/2024',
      status: 'Ativa',
      progresso: 75,
      descricao: 'Campanha focada em aumentar as vendas do último trimestre de 2024, com metas específicas para cada vendedor.',
      meta: 'R$ 500.000',
      premio: 'Viagem para Cancún + Bônus em dinheiro',
      regras: 'Vendas válidas apenas para novos clientes. Mínimo de 10 vendas por participante.',
      responsavel: 'João Silva',
      departamento: 'Vendas'
    },
    {
      id: 2,
      nome: 'Meta Dezembro',
      tipo: 'Performance',
      participantes: 32,
      pontos: 2000,
      pontosAdquiridos: 18400,
      pontosDistribuidos: 14200,
      pontosDisponiveis: 4200,
      inicio: '01/12/2024',
      fim: '31/12/2024',
      status: 'Ativa',
      progresso: 60,
      descricao: 'Campanha de performance para atingir as metas de dezembro e fechar o ano com chave de ouro.',
      meta: '120% da meta mensal',
      premio: 'Bônus de 2 salários + Reconhecimento',
      regras: 'Avaliação baseada em vendas, atendimento e pontualidade.',
      responsavel: 'Maria Santos',
      departamento: 'Comercial'
    },
    {
      id: 3,
      nome: 'Captação Novos Clientes',
      tipo: 'Aquisição',
      participantes: 28,
      pontos: 1200,
      pontosAdquiridos: 9800,
      pontosDistribuidos: 5600,
      pontosDisponiveis: 4200,
      inicio: '15/11/2024',
      fim: '15/01/2025',
      status: 'Ativa',
      progresso: 40,
      descricao: 'Foco na captação de novos clientes para expandir a base e aumentar o market share.',
      meta: '50 novos clientes',
      premio: 'Tablet + Vale-compras R$ 1.000',
      regras: 'Clientes devem ter primeira compra superior a R$ 500.',
      responsavel: 'Carlos Oliveira',
      departamento: 'Marketing'
    }
  ];

  const campanhasFinalizadas = [
    {
      id: 4,
      nome: 'Vendas Q3 2024',
      tipo: 'Vendas',
      participantes: 50,
      pontos: 1800,
      pontosAdquiridos: 22500,
      pontosDistribuidos: 22500,
      pontosDisponiveis: 0,
      inicio: '01/07/2024',
      fim: '30/09/2024',
      status: 'Finalizada',
      progresso: 100,
      descricao: 'Campanha de vendas do terceiro trimestre com excelentes resultados.',
      meta: 'R$ 400.000',
      premio: 'Bônus em dinheiro + Certificado',
      regras: 'Vendas válidas para todos os produtos da linha premium.',
      responsavel: 'Ana Costa',
      departamento: 'Vendas'
    },
    {
      id: 5,
      nome: 'Treinamento Produto',
      tipo: 'Capacitação',
      participantes: 65,
      pontos: 800,
      pontosAdquiridos: 15600,
      pontosDistribuidos: 15600,
      pontosDisponiveis: 0,
      inicio: '01/08/2024',
      fim: '31/08/2024',
      status: 'Finalizada',
      progresso: 100,
      descricao: 'Programa de capacitação sobre os novos produtos lançados.',
      meta: '100% de conclusão do treinamento',
      premio: 'Certificação + Vale-alimentação',
      regras: 'Participação obrigatória em todas as sessões.',
      responsavel: 'Pedro Lima',
      departamento: 'RH'
    }
  ];

  const getStatusColor = (status: string) => {
    return status === 'Ativa' ? 'bg-emerald-100 text-emerald-800' : 'bg-gray-100 text-gray-800';
  };

  const getTipoColor = (tipo: string) => {
    const colors = {
      'Vendas': 'bg-blue-100 text-blue-800',
      'Performance': 'bg-orange-100 text-orange-800',
      'Aquisição': 'bg-emerald-100 text-emerald-800',
      'Capacitação': 'bg-slate-100 text-slate-800'
    };
    return colors[tipo as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const campanhas = activeTab === 'ativas' ? campanhasAtivas : campanhasFinalizadas;

  const handleVerDetalhes = (campanha: any) => {
    setSelectedCampanha(campanha);
  };

  const closeDetalhes = () => {
    setSelectedCampanha(null);
  };

  const handleGerenciarParticipantes = (campanhaId: number) => {
    // Navegar para página de gerenciamento de participantes
    navigate('/admin/incentivo/campanhas/participantes', { state: { campanhaId } });
  };

  const handleEditarCampanha = (campanhaId: number) => {
    // Navegar para página de edição
    navigate(`/admin/incentivo/campanhas/dados-basicos?id=${campanhaId}&mode=edit`);
  };

  const handleDuplicarCampanha = (campanhaId: number) => {
    console.log('Duplicar campanha:', campanhaId);
    setShowDropdown(null);
  };

  const handleExportarDados = (campanhaId: number) => {
    console.log('Exportar dados da campanha:', campanhaId);
    setShowDropdown(null);
  };

  const handleArquivarCampanha = (campanhaId: number) => {
    console.log('Arquivar campanha:', campanhaId);
    setShowDropdown(null);
  };

  const handlePausarCampanha = (campanhaId: number) => {
    console.log('Pausar campanha:', campanhaId);
  };

  const handleNovaCampanha = () => {
    navigate('/admin/incentivo/campanhas/dados-basicos');
  };

  const flowchartSteps = [
    {
      step: 1,
      title: 'Dados Básicos',
      description: 'Configure informações fundamentais da campanha',
      icon: 'ri-file-text-line',
      color: 'bg-blue-500',
      items: [
        'Nome e descrição da campanha',
        'Tipo (Vendas, Performance, Aquisição)',
        'Período de vigência',
        'Público-alvo participante',
        'Status inicial'
      ]
    },
    {
      step: 2,
      title: 'Objetivos e Metas',
      description: 'Defina as metas que os participantes devem atingir',
      icon: 'ri-target-line',
      color: 'bg-emerald-500',
      items: [
        'Metas de vendas ou performance',
        'Valores e percentuais alvo',
        'Pesos por tipo de meta',
        'Critérios de avaliação',
        'Indicadores de sucesso'
      ]
    },
    {
      step: 3,
      title: 'Ações e Pontos',
      description: 'Configure quais ações geram pontos para os participantes',
      icon: 'ri-coin-line',
      color: 'bg-orange-500',
      items: [
        'Ações que geram pontos',
        'Pontuação por ação realizada',
        'Multiplicadores especiais',
        'Bonificações por volume',
        'Sistema de progressão'
      ]
    },
    {
      step: 4,
      title: 'Regras',
      description: 'Estabeleça as regras de participação e pontuação',
      icon: 'ri-shield-check-line',
      color: 'bg-purple-500',
      items: [
        'Critérios de participação',
        'Regras de pontuação',
        'Formação de equipes',
        'Penalidades e restrições',
        'Condições especiais'
      ]
    },
    {
      step: 5,
      title: 'Premiação',
      description: 'Defina os prêmios e recompensas da campanha',
      icon: 'ri-trophy-line',
      color: 'bg-yellow-500',
      items: [
        'Tipos de prêmios disponíveis',
        'Critérios de distribuição',
        'Ranking e classificação',
        'Premiação por categorias',
        'Cerimônia de entrega'
      ]
    }
  ];

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Campanhas de Incentivo</h1>
            <p className="text-gray-600 mt-1">Crie e gerencie suas campanhas de incentivo</p>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={() => setShowFlowchart(!showFlowchart)}
              className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={showFlowchart ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
              </div>
              <span>{showFlowchart ? 'Ocultar' : 'Mostrar'} Jornada</span>
            </button>
            <button
              onClick={handleNovaCampanha}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-add-line"></i>
              </div>
              <span>Nova Campanha</span>
            </button>
          </div>
        </div>

        {/* Organograma da Jornada */}
        {showFlowchart && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="mb-6">
              <h2 className="text-xl font-bold text-gray-900 mb-2">Jornada de Criação de Campanha</h2>
              <p className="text-gray-600">Siga estas 5 etapas para criar uma campanha completa e eficaz</p>
            </div>

            {/* Flowchart Steps */}
            <div className="relative">
              
              <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
                {flowchartSteps.map((step, index) => (
                  <div key={step.step} className="relative">
                    {/* Step Card */}
                    <div className={`border-2 rounded-lg p-4 hover:shadow-md transition-all duration-300 h-full flex flex-col ${
                      step.step === 1 ? 'bg-blue-50/50 border-blue-300 hover:border-blue-400' :
                      step.step === 2 ? 'bg-emerald-50/50 border-emerald-300 hover:border-emerald-400' :
                      step.step === 3 ? 'bg-orange-50/50 border-orange-300 hover:border-orange-400' :
                      step.step === 4 ? 'bg-purple-50/50 border-purple-300 hover:border-purple-400' :
                      'bg-yellow-50/50 border-yellow-300 hover:border-yellow-400'
                    }`}>
                      {/* Step Number and Icon */}
                      <div className="flex items-center justify-center mb-4">
                        <div className={`w-12 h-12 rounded-full ${step.color} flex items-center justify-center relative z-10`}>
                          <div className="w-6 h-6 flex items-center justify-center">
                            <i className={`${step.icon} text-white text-xl`}></i>
                          </div>
                        </div>
                      </div>

                      {/* Step Info */}
                      <div className="text-center mb-4 flex-shrink-0">
                        <div className="text-xs font-medium text-gray-500 mb-1">ETAPA {step.step}</div>
                        <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
                        <p className="text-sm text-gray-600">{step.description}</p>
                      </div>

                      {/* Step Details */}
                      <div className="space-y-2 flex-grow">
                        {step.items.map((item, itemIndex) => (
                          <div key={itemIndex} className="flex items-start space-x-2">
                            <div className="w-1.5 h-1.5 rounded-full bg-gray-400 mt-2 flex-shrink-0"></div>
                            <span className="text-xs text-gray-600">{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Arrow (except for last item) */}
                    {index < flowchartSteps.length - 1 && (
                      <div className="hidden lg:block absolute top-16 -right-3 z-20">
                        <div className="w-6 h-6 bg-white border-2 border-gray-200 rounded-full flex items-center justify-center">
                          <div className="w-3 h-3 flex items-center justify-center">
                            <i className="ri-arrow-right-line text-gray-400 text-sm"></i>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Summary Box */}
            <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-lightbulb-line text-white"></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-blue-900 mb-2">Como Funciona a Jornada</h3>
                  <div className="text-sm text-blue-800 space-y-2">
                    <p><strong>1. Sequencial:</strong> Cada etapa deve ser concluída antes de avançar para a próxima</p>
                    <p><strong>2. Flexível:</strong> Você pode salvar rascunhos e voltar para editar qualquer etapa</p>
                    <p><strong>3. Validação:</strong> O sistema valida se todas as informações necessárias foram preenchidas</p>
                    <p><strong>4. Prévia:</strong> Antes de ativar, você pode revisar toda a configuração da campanha</p>
                    <p><strong>5. Ativação:</strong> Após finalizar todas as etapas, a campanha fica disponível para os participantes</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Campanhas Ativas</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">3</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-emerald-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-megaphone-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total Participantes</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">105</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-group-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Pontos Distribuídos</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">4.700</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-orange-500 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-coin-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Taxa de Sucesso</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">85%</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-slate-600 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-trophy-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Area with Two Columns */}
        <div className="flex space-x-6">
          {/* Campaigns List - Left Column */}
          <div className={`transition-all duration-300 ${selectedCampanha ? 'w-2/3' : 'w-full'}`}>
            {/* Tabs */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
              <div className="border-b border-gray-200">
                <nav className="flex space-x-8 px-6">
                  <button
                    onClick={() => setActiveTab('ativas')}
                    className={`py-4 px-1 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap ${
                      activeTab === 'ativas'
                        ? 'border-blue-600 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    Campanhas Ativas ({campanhasAtivas.length})
                  </button>
                  <button
                    onClick={() => setActiveTab('finalizadas')}
                    className={`py-4 px-1 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap ${
                      activeTab === 'finalizadas'
                        ? 'border-blue-600 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    Finalizadas ({campanhasFinalizadas.length})
                  </button>
                </nav>
              </div>

              {/* Campaigns List */}
              <div className="p-6">
                <div className="space-y-4">
                  {campanhas.map((campanha) => (
                    <div key={campanha.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                      <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center space-x-4">
                          <h3 className="text-lg font-semibold text-gray-900">{campanha.nome}</h3>
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getTipoColor(campanha.tipo)}`}>
                            {campanha.tipo}
                          </span>
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(campanha.status)}`}>
                            {campanha.status}
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <button 
                            onClick={() => handleEditarCampanha(campanha.id)}
                            className="text-gray-400 hover:text-gray-600 cursor-pointer"
                            title="Editar Campanha"
                          >
                            <div className="w-5 h-5 flex items-center justify-center">
                              <i className="ri-edit-line"></i>
                            </div>
                          </button>
                          <div className="relative">
                            <button 
                              onClick={() => setShowDropdown(showDropdown === campanha.id ? null : campanha.id)}
                              className="text-gray-400 hover:text-gray-600 cursor-pointer"
                              title="Mais opções"
                            >
                              <div className="w-5 h-5 flex items-center justify-center">
                                <i className="ri-more-2-line"></i>
                              </div>
                            </button>
                            
                            {/* Dropdown Menu */}
                            {showDropdown === campanha.id && (
                              <div className="absolute right-0 top-8 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-10">
                                <button
                                  onClick={() => handleDuplicarCampanha(campanha.id)}
                                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center space-x-2 cursor-pointer"
                                >
                                  <div className="w-4 h-4 flex items-center justify-center">
                                    <i className="ri-file-copy-line"></i>
                                  </div>
                                  <span>Duplicar Campanha</span>
                                </button>
                                <button
                                  onClick={() => handleExportarDados(campanha.id)}
                                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center space-x-2 cursor-pointer"
                                >
                                  <div className="w-4 h-4 flex items-center justify-center">
                                    <i className="ri-download-line"></i>
                                  </div>
                                  <span>Exportar Dados</span>
                                </button>
                                <button
                                  onClick={() => handleGerenciarParticipantes(campanha.id)}
                                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center space-x-2 cursor-pointer"
                                >
                                  <div className="w-4 h-4 flex items-center justify-center">
                                    <i className="ri-group-line"></i>
                                  </div>
                                  <span>Ver Participantes</span>
                                </button>
                                <div className="border-t border-gray-100 my-1"></div>
                                <button
                                  onClick={() => handleArquivarCampanha(campanha.id)}
                                  className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center space-x-2 cursor-pointer"
                                >
                                  <div className="w-4 h-4 flex items-center justify-center">
                                    <i className="ri-archive-line"></i>
                                  </div>
                                  <span>Arquivar Campanha</span>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-group-line text-gray-500"></i>
                          </div>
                          <span className="text-sm text-gray-600">{campanha.participantes} participantes</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-calendar-line text-gray-500"></i>
                          </div>
                          <span className="text-sm text-gray-600">{campanha.inicio} - {campanha.fim}</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-bar-chart-line text-gray-500"></i>
                          </div>
                          <span className="text-sm text-gray-600">{campanha.progresso}% concluído</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-trophy-line text-gray-500"></i>
                          </div>
                          <span className="text-sm text-gray-600">{campanha.status}</span>
                        </div>
                      </div>

                      {/* Informações de Pontos */}
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                        <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-3">
                          <div className="flex items-center justify-between">
                            <div>
                              <p className="text-xs font-medium text-emerald-700">Pontos Adquiridos</p>
                              <p className="text-lg font-bold text-emerald-900 mt-1">{campanha.pontosAdquiridos.toLocaleString('pt-BR')}</p>
                            </div>
                            <div className="w-8 h-8 rounded-lg bg-emerald-500 flex items-center justify-center">
                              <div className="w-4 h-4 flex items-center justify-center">
                                <i className="ri-add-circle-line text-white"></i>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bg-orange-50 border border-orange-200 rounded-lg p-3">
                          <div className="flex items-center justify-between">
                            <div>
                              <p className="text-xs font-medium text-orange-700">Pontos Distribuídos</p>
                              <p className="text-lg font-bold text-orange-900 mt-1">{campanha.pontosDistribuidos.toLocaleString('pt-BR')}</p>
                            </div>
                            <div className="w-8 h-8 rounded-lg bg-orange-500 flex items-center justify-center">
                              <div className="w-4 h-4 flex items-center justify-center">
                                <i className="ri-gift-line text-white"></i>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                          <div className="flex items-center justify-between">
                            <div>
                              <p className="text-xs font-medium text-blue-700">Pontos Disponíveis</p>
                              <p className="text-lg font-bold text-blue-900 mt-1">{campanha.pontosDisponiveis.toLocaleString('pt-BR')}</p>
                            </div>
                            <div className="w-8 h-8 rounded-lg bg-blue-500 flex items-center justify-center">
                              <div className="w-4 h-4 flex items-center justify-center">
                                <i className="ri-wallet-line text-white"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Progress Bar */}
                      <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
                        <div
                          className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                          style={{ width: `${campanha.progresso}%` }}
                        ></div>
                      </div>

                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                          <button 
                            onClick={() => handleVerDetalhes(campanha)}
                            className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer whitespace-nowrap"
                          >
                            Ver Detalhes
                          </button>
                          <button 
                            onClick={() => handleGerenciarParticipantes(campanha.id)}
                            className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer whitespace-nowrap"
                          >
                            Gerenciar Participantes
                          </button>
                        </div>
                        {campanha.status === 'Ativa' && (
                          <button 
                            onClick={() => handlePausarCampanha(campanha.id)}
                            className="text-orange-600 hover:text-orange-800 text-sm cursor-pointer whitespace-nowrap"
                          >
                            Pausar Campanha
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Details Panel - Right Column */}
          {selectedCampanha && (
            <div className="w-1/3 bg-white rounded-lg shadow-sm border border-gray-200 p-6 h-fit">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-gray-900">Detalhes da Campanha</h3>
                <button
                  onClick={closeDetalhes}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              {/* Campaign Header */}
              <div className="mb-6">
                <div className="flex items-center space-x-3 mb-3">
                  <h4 className="text-xl font-bold text-gray-900">{selectedCampanha.nome}</h4>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(selectedCampanha.status)}`}>
                    {selectedCampanha.status}
                  </span>
                </div>
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${getTipoColor(selectedCampanha.tipo)}`}>
                  {selectedCampanha.tipo}
                </span>
              </div>

              {/* Progress */}
              <div className="mb-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-medium text-gray-700">Progresso</span>
                  <span className="text-sm font-bold text-gray-900">{selectedCampanha.progresso}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div
                    className="bg-blue-600 h-3 rounded-full transition-all duration-300"
                    style={{ width: `${selectedCampanha.progresso}%` }}
                  ></div>
                </div>
              </div>

              {/* Details Grid */}
              <div className="space-y-4">
                <div className="border-b border-gray-100 pb-4">
                  <h5 className="text-sm font-semibold text-gray-700 mb-2">Informações Gerais</h5>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Participantes</span>
                      <span className="text-sm font-medium text-gray-900">{selectedCampanha.participantes}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Responsável</span>
                      <span className="text-sm font-medium text-gray-900">{selectedCampanha.responsavel}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Departamento</span>
                      <span className="text-sm font-medium text-gray-900">{selectedCampanha.departamento}</span>
                    </div>
                  </div>
                </div>

                <div className="border-b border-gray-100 pb-4">
                  <h5 className="text-sm font-semibold text-gray-700 mb-2">Pontuação</h5>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Pontos Adquiridos</span>
                      <span className="text-sm font-bold text-emerald-600">{selectedCampanha.pontosAdquiridos?.toLocaleString('pt-BR')}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Pontos Distribuídos</span>
                      <span className="text-sm font-bold text-orange-600">{selectedCampanha.pontosDistribuidos?.toLocaleString('pt-BR')}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Pontos Disponíveis</span>
                      <span className="text-sm font-bold text-blue-600">{selectedCampanha.pontosDisponiveis?.toLocaleString('pt-BR')}</span>
                    </div>
                  </div>
                </div>

                <div className="border-b border-gray-100 pb-4">
                  <h5 className="text-sm font-semibold text-gray-700 mb-2">Período</h5>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Início</span>
                      <span className="text-sm font-medium text-gray-900">{selectedCampanha.inicio}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">Fim</span>
                      <span className="text-sm font-medium text-gray-900">{selectedCampanha.fim}</span>
                    </div>
                  </div>
                </div>

                <div className="border-b border-gray-100 pb-4">
                  <h5 className="text-sm font-semibold text-gray-700 mb-2">Descrição</h5>
                  <p className="text-sm text-gray-600">{selectedCampanha.descricao}</p>
                </div>

                <div className="border-b border-gray-100 pb-4">
                  <h5 className="text-sm font-semibold text-gray-700 mb-2">Meta</h5>
                  <p className="text-sm font-medium text-gray-900">{selectedCampanha.meta}</p>
                </div>

                <div className="border-b border-gray-100 pb-4">
                  <h5 className="text-sm font-semibold text-gray-700 mb-2">Premiação</h5>
                  <p className="text-sm text-gray-600">{selectedCampanha.premio}</p>
                </div>

                <div className="pb-4">
                  <h5 className="text-sm font-semibold text-gray-700 mb-2">Regras</h5>
                  <p className="text-sm text-gray-600">{selectedCampanha.regras}</p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-6 pt-6 border-t border-gray-100 space-y-3">
                <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
                  Editar Campanha
                </button>
                <button className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
                  Gerenciar Participantes
                </button>
                {selectedCampanha.status === 'Ativa' && (
                  <button className="w-full bg-orange-100 hover:bg-orange-200 text-orange-700 py-2 px-4 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
                    Pausar Campanha
                  </button>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Create Campaign Modal */}
        {showCreateModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-gray-900">Nova Campanha</h3>
                <button
                  onClick={() => setShowCreateModal(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Campanha</label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    placeholder="Digite o nome da campanha"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Campanha</label>
                  <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8">
                    <option value="">Selecione o tipo</option>
                    <option value="vendas">Vendas</option>
                    <option value="performance">Performance</option>
                    <option value="aquisicao">Aquisição</option>
                    <option value="capacitacao">Capacitação</option>
                  </select>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Data Início</label>
                    <input
                      type="date"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Data Fim</label>
                    <input
                      type="date"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Pontos por Meta</label>
                  <input
                    type="number"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    placeholder="Ex: 100"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Descrição</label>
                  <textarea
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                    placeholder="Descreva os objetivos da campanha"
                  ></textarea>
                </div>

                <div className="flex items-center justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => setShowCreateModal(false)}
                    className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Criar Campanha
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Click outside to close dropdown */}
        {showDropdown && (
          <div 
            className="fixed inset-0 z-5" 
            onClick={() => setShowDropdown(null)}
          ></div>
        )}
      </div>
    </Layout>
  );
}